export default {
  en: {    
  	offer: {
		  discount : {
  			'7days' : '5% discount | payment in 7 days',
        '30days' : '2% discount | payment in 30 days',
        '60days' : 'No discount | payment in 60 days',
  		},
      adminfee: '{0}% discount | admin fee',
      total: 'Subtotal (excl. VAT)',
      totalvat: 'Total amount (incl. VAT {0}%)',
      invoicereferencedisclaimer: 'Don\'t forget to include our reference number in your invoice.',
      selfbilling: 'Vengo uses self-billing to compensate carriers. More info can be found <a target="_blank" href="https://www.vengo.technology/en/good-to-know/faster-payment-via-self-billing">here</a>.',
      notavailable: 'No offers available',
      notavailabledisclaimer: 'You have no pending offers at the moment, Go to search and bid on a shipment.',
      adddriver: {
        add: 'Assign a driver',
        search: 'Search a driver...',
        notfound: 'No drivers found.',
        addcta: 'Add one.',
      }
  	}
  },
  nl: {    
  	offer: {
  		discount : {
        '7days' : '5% korting | betaling binnen 7 dagen',
        '30days' : '2% korting | betaling binnen 30 dagen',
        '60days' : 'Geen korting | betaling binnen 60 dagen',
    	},
      adminfee: '{0}% korting | administratiekost',
      total: 'Subtotaal (excl. BTW)',
      totalvat: 'Totaal (incl. BTW {0}%)',
      invoicereferencedisclaimer: 'Vergeet niet om ons referentienummer op je factuur te vermelden.',
      notavailable: 'Geen boden beschikbaar',
      notavailabledisclaimer: 'Je hebt momenteel geen openstaande boden. Ga naar zoeken en bied op een zending.',
      selfbilling: 'Vengo maakt gebruikt van self-billing om vervoerders te vergoeden. Meer info vind je <a target="_blank" href="https://www.vengo.technology/nl/leuk-om-weten/sneller-uitbetaald-worden-via-self-billing">hier</a>.',
      adddriver: {
        add: 'Wijs een chauffeur toe',
        search: 'Zoek een chauffeur...',
        notfound: 'Geen chauffeurs gevonden.',
        addcta: 'Voeg een toe.',        
      }      
  	}
  },
  fr: {    
  offer: {
      discount : {
        '7days' : '5% réduction | paiement dans 7 jours',
        '30days' : '2% réduction | paiement dans 30 jours',
        '60days' : 'Pas de réduction | paiement dans 60 jours',
      },
      adminfee: "{0}% réduction | frais d'administration",
      total: 'Sous-total (hors TVA)',
      totalvat: 'Montant total (TTA {0}%)',
      invoicereferencedisclaimer: 'N\'oubliez pas de mentionner notre numéro de référence sur votre facture.',
      notavailable: 'Pas d\'offre disponible',
      notavailabledisclaimer: 'Actuellement, vous n\'avez aucune offre en attente. Aller à rechercher et faire une offre',
      selfbilling: 'Vengo utilise l\'auto-facturation pour indemniser les opérateurs. Plus d\'infos peuvent être trouvées <a target="_blank" href="https://www.vengo.technology/fr/good-to-know/paiement-plus-rapide-grace-a-lauto-facturation">ici</a>.',
      adddriver: {
        add: 'Assigne un chauffeur',
        search: 'Cherche un chauffeur...',
        notfound: 'Aucun chauffeur trouvé.',
        addcta: 'Ajoute un.',        
      }      
    }
  }  
}
